<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="v_tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :height="height"
      size="small"
      resizable
      border
      :edit-config="{
        trigger: 'click',
        mode: 'row',
      }"
      :sort-config="{
        multiple: true,
        trigger: 'cell',
        chronological: true,
        defaultSort: [
          { field: 'contractNo', order: 'asc' },
          { field: 'retailerPo', order: 'asc' },
          { field: 'importerPo', order: 'asc' },
          { field: 'orderGoodsItemNo', order: 'asc' },
        ],
      }"
      @edit-closed="onEditClosed"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">{{
              $l('INDEX.form_label_box') || '发运单装柜明细'
            }}</span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              v-if="!disabled"
              class="mr-2"
              size="sm"
              variant="outline-info"
              @click="() => (lclVisible = true)"
              >{{ $l('INDEX.tips_select_shipmentBatch') || '选择装柜批次' }}
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:batchAmount="{ row }">
        <span>{{ row.batchAmount }} {{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:batchSalePrice="{ row }">
        <span>{{ row.batchSalePrice }} {{ row.v_salesCurrencyUnit }}</span>
      </template>
      <template v-slot:containerBoxQtyWait="{ row }">
        <span>{{ row.batchBoxQty - row.containerBoxQty }}</span>
      </template>
      <template v-slot:boxPriceAmount="{ row }">
        <span>{{ row.boxPriceAmount || 0 }} {{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:boxSalePriceAmount="{ row }">
        <span>
          {{ row.boxSalePriceAmount || 0 }} {{ row.v_salesCurrencyUnit }}
        </span>
      </template>
      <template v-slot:containerBoxPriceAmount="{ row }">
        <span
          >{{ row.containerBoxPriceAmount || 0 }} {{ row.v_currencyUnit }}</span
        >
      </template>
      <template v-slot:containerBoxSalePriceAmount="{ row }">
        <span>
          {{ row.containerBoxSalePriceAmount || 0 }}
          {{ row.v_salesCurrencyUnit }}
        </span>
      </template>

      <template v-slot:opt="{ row }">
        <i
          class="el-icon-delete tool-btn"
          v-if="!disabled"
          @click="remove(row)"
        ></i>
      </template>
      <template v-slot:deliveryTypeHeader>
        <filter-content
          :text="$l('INDEX.table_label_deliveryType') || '出货方式'"
          :items="deliveryTypeOptions"
          @filter="(e) => (deliveryTypeFilter = e)"
          submitFilterOnClose
        />
      </template>
      <template v-slot:contractNoHeader>
        <filter-content
          :text="$l('INDEX.table_label_contractNo') || '合同号'"
          :items="contractNoOptions"
          @filter="(e) => (contractNoFilter = e)"
          submitFilterOnClose
        />
      </template>
      <template v-slot:retailerPoHeader>
        <filter-content
          :text="$l('INDEX.table_label_retailerPo') || '零售商PO'"
          :items="retailerPoOptions"
          @filter="(e) => (retailerPoFilter = e)"
          submitFilterOnClose
        />
      </template>
      <template v-slot:orderGoodsItemNoHeader>
        <filter-content
          :text="$l('INDEX.table_label_orderGoodsItemNo') || 'Item No'"
          :items="orderGoodsItemNoOptions"
          @filter="(e) => (orderGoodsItemNoFilter = e)"
          submitFilterOnClose
        />
      </template>
      <template v-slot:importerPoHeader>
        <filter-content
          :text="$l('INDEX.table_label_importerPo') || '进口商PO'"
          :items="importerPoOptions"
          @filter="(e) => (importerPoFilter = e)"
          submitFilterOnClose
        />
      </template>
      <template v-slot:dispatchPortHeader>
        <filter-content
          :text="$l('INDEX.table_label_dispatchPort') || '发运港口'"
          :items="dispatchPortOptions"
          @filter="(e) => (dispatchPortFilter = e)"
          submitFilterOnClose
        />
      </template>
      <template v-slot:destinationPortHeader>
        <filter-content
          :text="$l('INDEX.table_label_destinationPort') || '目的港口'"
          :items="destinationPortOptions"
          @filter="(e) => (destinationPortFilter = e)"
          submitFilterOnClose
        />
      </template>
      <template v-slot:deliveryDateHeader>
        <filter-content
          :text="$l('INDEX.form_label_cargoReadyDay') || '货好时间'"
          :items="deliveryDateOptions"
          @filter="(e) => (deliveryDateFilter = e)"
          submitFilterOnClose
        />
      </template>
      <template v-slot:shipmentDateHeader>
        <filter-content
          :text="
            $l('INDEX.order_form_batch_label_shipmentStartDate') ||
            '客户最早交期'
          "
          :items="shipmentDateOptions"
          @filter="(e) => (shipmentDateFilter = e)"
          submitFilterOnClose
        />
      </template>
      <template v-slot:shipmentEndDateHeader>
        <filter-content
          :text="
            $l('INDEX.order_form_batch_label_shipmentEndDate') || '客户最晚交期'
          "
          :items="shipmentEndDateOptions"
          @filter="(e) => (shipmentEndDateFilter = e)"
          submitFilterOnClose
        />
      </template>
      <template v-slot:identifyGoodsNoHeader>
        <filter-content
          :text="
            $l('INDEX.order_goods_label_identifyGoodsNo') || '产品识别编号'
          "
          :items="identifyGoodsNoOptions"
          @filter="(e) => (identifyGoodsNoFilter = e)"
          submitFilterOnClose
        />
      </template>
      <template v-slot:executeScmHeader>
        <filter-content
          :text="$l('INDEX.table_label_execution_plant') || '执行工厂'"
          :items="executeScmNameOptions"
          @filter="(e) => (executeScmNameFilter = e)"
          submitFilterOnClose
        />
      </template>
      <template v-slot:settlementFactoryHeader>
        <filter-content
          :text="$l('INDEX.table_label_settlementFactoryName') || '结算工厂'"
          :items="settlementFactoryNameOptions"
          @filter="(e) => (settlementFactoryNameFilter = e)"
          submitFilterOnClose
        />
      </template>
      <template v-slot:orderExecuteTypeHeader>
        <filter-content
          :text="$l('INDEX.table_label_orderExecuteType') || '业务性质'"
          :items="orderExecuteTypeOptions"
          @filter="(e) => (orderExecuteTypeFilter = e)"
          submitFilterOnClose
        />
      </template>
    </vxe-grid>
    <LCLDialog
      :visible.sync="lclVisible"
      :title="
        $l('INDEX.form_label_shipmentBatch_information') || '发运单批次明细'
      "
      :shipmentCode="shipmentCode"
      :chooseContainer="false"
      @confirm="onLCLConfirm"
    />
  </div>
</template>
<script>
import LCLDialog from '../lcl'
import EditLoading from '@/mixins/edit-loading'
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [EditLoading, TableAutoHeight],
  components: { LCLDialog },
  props: {
    disabled: { type: Boolean, default: false },
    isExpand: { type: Boolean, default: false },
    shipmentCode: { type: String, default: '' },
    shipmentContainerCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      v_tableData: [],
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          fixed: 'left',
          width: 85,
          visible: !this.disabled,
          slots: {
            default: 'opt',
          },
        },
        {
          title: this.$l('INDEX.form_label_boxQty') || '入柜箱数',
          field: 'containerBoxQty',
          width: 120,
          fixed: 'left',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          editRender: {
            name: 'ElInputNumber',
            props: {
              controlsPosition: 'right',
              style: 'width:100%',
              min: 1,
              step: 1,
              precision: 0,
              disabled: this.disabled,
            },
            placeholder: '请输入数量',
            immediate: true,
          },
        },
        {
          title: this.$l('INDEX.form_label_articleNoDate') || '出货日期',
          field: 'deliveryDate',
          width: 120,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          slots: {
            header: 'deliveryDateHeader',
          },
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_shipmentStartDate') ||
            '客户交期',
          field: 'shipmentDate',
          headerAlign: 'center',
          align: 'center',
          width: 140,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          slots: {
            header: 'shipmentDateHeader',
          },
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_shipmentEndDate') ||
            '客户交期',
          field: 'shipmentEndDate',
          headerAlign: 'center',
          align: 'center',
          width: 140,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          slots: {
            header: 'shipmentEndDateHeader',
          },
        },
        {
          title: this.$l('INDEX.table_label_destinationPort') || '目的港口',
          field: 'v_destinationPort',
          minWidth: 120,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          slots: {
            header: 'destinationPortHeader',
          },
        },
        {
          title: this.$l('INDEX.table_label_deliveryType') || '出货方式',
          field: 'v_deliveryType',
          minWidth: 150,
          align: 'center',
          showOverflow: true,
          sortable: true,
          slots: {
            header: 'deliveryTypeHeader',
          },
        },
        {
          title: this.$l('INDEX.table_label_contractNo') || '合同号',
          field: 'contractNo',
          minWidth: 150,
          align: 'center',
          showOverflow: true,
          sortable: true,
          slots: {
            header: 'contractNoHeader',
          },
        },
        {
          title: this.$l('INDEX.table_label_retailerPo') || '零售商PO',
          field: 'retailerPo',
          minWidth: 150,
          align: 'center',
          showOverflow: true,
          sortable: true,
          slots: {
            header: 'retailerPoHeader',
          },
        },
        {
          title: this.$l('INDEX.table_label_orderGoodsItemNo') || 'Item No',
          field: 'orderGoodsItemNo',
          minWidth: 150,
          align: 'center',
          showOverflow: true,
          sortable: true,
          slots: {
            header: 'orderGoodsItemNoHeader',
          },
        },
        {
          title:
            this.$l('INDEX.order_goods_label_identifyGoodsNo') ||
            '产品识别编号',
          field: 'identifyGoodsNo',
          align: 'center',
          headerAlign: 'center',
          width: 200,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          slots: {
            header: 'identifyGoodsNoHeader',
          },
        },
        {
          title: this.$l('INDEX.table_label_execution_plant') || '执行工厂',
          field: 'executeScmName',
          align: 'center',
          headerAlign: 'center',
          width: 140,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          slots: {
            header: 'executeScmHeader',
          },
        },
        {
          title:
            this.$l('INDEX.table_label_settlementFactoryName') || '结算工厂',
          field: 'settlementFactoryName',
          align: 'center',
          headerAlign: 'center',
          width: 140,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          slots: {
            header: 'settlementFactoryHeader',
          },
        },
        {
          title: this.$l('INDEX.table_label_orderExecuteType') || '业务性质',
          field: 'v_orderExecuteType',
          align: 'center',
          headerAlign: 'center',
          width: 120,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          slots: {
            header: 'orderExecuteTypeHeader',
          },
        },
        {
          title: this.$l('INDEX.form_boxLength_cm') || '箱长（cm）',
          field: 'boxLength',
          width: 110,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
        },
        {
          title: this.$l('INDEX.form_boxWidth_cm') || '箱宽（cm）',
          field: 'boxWidth',
          width: 110,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
        },
        {
          title: this.$l('INDEX.form_boxHeight_cm') || '箱高（cm）',
          field: 'boxHeight',
          width: 110,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
        },
        {
          title: this.$l('INDEX.table_boxVolume') || '箱体积（立方米）',
          field: 'boxVolume',
          width: 130,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          field: 'v_packingType',
          align: 'center',
          headerAlign: 'center',
          width: 110,
          title: this.$l('INDEX.order_package_packingType') || '装箱方式',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_goodsNameDisplay') || '产品说明',
          field: 'goodsNameDisplay',
          align: 'center',
          headerAlign: 'center',
          width: 250,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.table_label_goods_spec_display') || '规格尺寸说明',
          field: 'goodsSpecDisplay',
          align: 'center',
          headerAlign: 'center',
          minWidth: 150,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_dispatchPort') || '发运港口',
          field: 'v_dispatchPort',
          width: 120,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          slots: {
            header: 'dispatchPortHeader',
          },
        },
        {
          title: this.$l('INDEX.table_label_importerPo') || '进口商PO',
          field: 'importerPo',
          minWidth: 150,
          align: 'center',
          showOverflow: true,
          sortable: true,
          slots: {
            header: 'importerPoHeader',
          },
        },
        {
          title: this.$l('INDEX.table_batchGoodsQty') || '批次产品总数量',
          field: 'batchGoodsQty',
          width: 150,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
        },
        {
          title: this.$l('INDEX.table_label_batchBoxGoodsQty') || '产品数量',
          field: 'containerGoodsQty',
          align: 'center',
          headerAlign: 'center',
          width: 110,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.form_label_bookingBoxLength_cm') || '订舱箱长(m)',
          field: 'bookingBoxLength',
          width: 110,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.form_label_bookingBoxWidth_cm') || '订舱箱宽(m)',
          field: 'bookingBoxWidth',
          width: 110,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.form_label_bookingBoxHeight_cm') || '订舱箱高(m)',
          field: 'bookingBoxHeight',
          width: 110,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.form_label_bookingBoxVolume') || '订舱箱体积(m³)',
          field: 'bookingBoxVolume',
          width: 110,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_boxGoodsQty') || '单箱产品数量',
          field: 'boxGoodsQty',
          align: 'center',
          headerAlign: 'center',
          width: 110,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.table_label_box_net_weight') || '单箱净重（kg）',
          field: 'boxNetWeight',
          align: 'center',
          headerAlign: 'center',
          width: 130,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.table_label_box_gross_weight') || '单箱毛重（kg）',
          field: 'boxGrossWeight',
          align: 'center',
          headerAlign: 'center',
          width: 130,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.table_label_box_price_amount') || '单箱成本总价',
          field: 'boxPriceAmount',
          align: 'center',
          headerAlign: 'center',
          width: 150,
          showHeaderOverflow: true,
          showOverflow: true,
          slots: {
            default: 'boxPriceAmount',
          },
        },
        {
          title:
            this.$l('INDEX.table_label_box_sale_price_amount') ||
            '单箱销售总价',
          field: 'boxSalePriceAmount',
          align: 'center',
          headerAlign: 'center',
          width: 150,
          showHeaderOverflow: true,
          showOverflow: true,
          slots: {
            default: 'boxSalePriceAmount',
          },
        },

        {
          title:
            this.$l('INDEX.form_label_containerBoxNetWeight') ||
            '入柜总箱净重(kg)',
          field: 'containerBoxNetWeight',
          width: 110,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.form_label_containerBoxGrossWeight') ||
            '入柜总箱毛重(kg)',
          field: 'containerBoxGrossWeight',
          width: 110,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.form_label_containerBoxPriceAmount') ||
            '入柜总箱成本总价',
          field: 'containerBoxPriceAmount',
          width: 150,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          slots: {
            default: 'containerBoxPriceAmount',
          },
        },
        {
          title:
            this.$l('INDEX.form_label_containerBoxSalePriceAmount') ||
            '入柜总箱销售总价',
          field: 'containerBoxSalePriceAmount',
          width: 150,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          slots: {
            default: 'containerBoxSalePriceAmount',
          },
        },
      ],
      lclVisible: false,
      contractNoFilter: [],
      deliveryTypeFilter: [],
      retailerPoFilter: [],
      orderGoodsItemNoFilter: [],
      importerPoFilter: [],
      dispatchPortFilter: [],
      destinationPortFilter: [],
      deliveryDateFilter: [],
      shipmentDateFilter: [],
      shipmentEndDateFilter: [],
      identifyGoodsNoFilter: [],
      executeScmNameFilter: [],
      settlementFactoryNameFilter: [],
      orderExecuteTypeFilter: [],
    }
  },
  computed: {
    height() {
      if (this.isExpand) return 300
      return this.tableHeight - 50 < 440 ? 440 : this.tableHeight - 50
    },
    deliveryTypeOptions() {
      const data = this.tableData
      return Array.from(
        new Set(data.map((i) => i.v_deliveryType).filter(Boolean))
      )
    },
    contractNoOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.contractNo)))
    },
    retailerPoOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.retailerPo)))
    },
    orderGoodsItemNoOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.orderGoodsItemNo)))
    },
    importerPoOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.importerPo)))
    },
    dispatchPortOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.v_dispatchPort)))
    },
    destinationPortOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.v_destinationPort)))
    },
    deliveryDateOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.deliveryDate)))
    },
    shipmentDateOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.shipmentDate)))
    },
    shipmentEndDateOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.shipmentEndDate)))
    },
    identifyGoodsNoOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.identifyGoodsNo)))
    },
    executeScmNameOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.executeScmName)))
    },
    settlementFactoryNameOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.settlementFactoryName)))
    },
    orderExecuteTypeOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.v_orderExecuteType)))
    },
    filterParams() {
      return {
        contractNoFilter: this.contractNoFilter || [],
        deliveryTypeFilter: this.deliveryTypeFilter || [],
        retailerPoFilter: this.retailerPoFilter || [],
        orderGoodsItemNoFilter: this.orderGoodsItemNoFilter || [],
        importerPoFilter: this.importerPoFilter || [],
        dispatchPortFilter: this.dispatchPortFilter || [],
        destinationPortFilter: this.destinationPortFilter || [],
        deliveryDateFilter: this.deliveryDateFilter || [],
        shipmentDateFilter: this.shipmentDateFilter || [],
        shipmentEndDateFilter: this.shipmentEndDateFilter || [],
        identifyGoodsNoFilter: this.identifyGoodsNoFilter || [],
        executeScmNameFilter: this.executeScmNameFilter || [],
        settlementFactoryNameFilter: this.settlementFactoryNameFilter || [],
        orderExecuteTypeFilter: this.orderExecuteTypeFilter || [],
      }
    },
  },
  watch: {
    filterParams: {
      handler() {
        this.filterData()
      },
      deep: true,
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.shipmentContainerCode) return
      this.$api
        .shipmentContainerBoxListApi({
          shipmentContainerCode: this.shipmentContainerCode,
        })
        .then((res) => {
          this.tableData = res.body.data
          this.v_tableData = res.body.data
        })
    },
    remove({ shipmentContainerBoxCode }) {
      this.$confirm('您确定要删除该数据吗?').then((type) => {
        if (type === 'confirm') {
          this.$api
            .shipmentContainerBoxDelApi({ shipmentContainerBoxCode })
            .then(() => {
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
                type: 'success',
              })
              this.loadData()
              this.$emit('reload')
            })
        }
      })
    },
    onEditClosed({ row }) {
      if (this.disabled) return
      this.loadingOpen()
      this.$api
        .shipmentContainerBoxSaveApi({
          shipmentContainerBoxList: [row],
          shipmentCode: this.shipmentCode,
          shipmentContainerCode: this.shipmentContainerCode,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(res.msg)
            return
          }
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.loadData()
          this.$emit('reload')
        })
        .catch(() => {
          this.loadData()
          this.loadingClose()
        })
    },
    onLCLConfirm({ listBox }) {
      if (!listBox) return
      const shipmentContainerBoxList = listBox.map((m) => {
        return {
          shipmentBatchBoxCode: m.shipmentBatchBoxCode,
          containerBoxQty: m.containerBoxQty,
        }
      })
      this.loadingOpen()
      this.$api
        .shipmentContainerBoxSaveApi({
          shipmentContainerBoxList,
          shipmentCode: this.shipmentCode,
          shipmentContainerCode: this.shipmentContainerCode,
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.loadData()
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    filterData() {
      const {
        contractNoFilter,
        deliveryTypeFilter,
        retailerPoFilter,
        orderGoodsItemNoFilter,
        importerPoFilter,
        dispatchPortFilter,
        destinationPortFilter,
        deliveryDateFilter,
        shipmentDateFilter,
        identifyGoodsNoFilter,
        executeScmNameFilter,
        settlementFactoryNameFilter,
        orderExecuteTypeFilter,
      } = this.filterParams
      let data = this.tableData
      // 筛选出货方式
      if (deliveryTypeFilter && deliveryTypeFilter.length) {
        data = data.filter((i) => deliveryTypeFilter.includes(i.v_deliveryType))
      }
      // 1、筛选合同号
      if (contractNoFilter && contractNoFilter.length) {
        data = data.filter((i) => contractNoFilter.includes(i.contractNo))
      }
      // 2、筛选零售商PO
      if (retailerPoFilter && retailerPoFilter.length) {
        data = data.filter((i) => retailerPoFilter.includes(i.retailerPo))
      }
      if (orderGoodsItemNoFilter && orderGoodsItemNoFilter.length) {
        data = data.filter((i) => orderGoodsItemNoFilter.includes(i.orderGoodsItemNo))
      }
      // 3、筛选进口商PO
      if (importerPoFilter && importerPoFilter.length) {
        data = data.filter((i) => importerPoFilter.includes(i.importerPo))
      }
      //筛选发运港口
      if (dispatchPortFilter && dispatchPortFilter.length) {
        data = data.filter((i) => dispatchPortFilter.includes(i.v_dispatchPort))
      }
      //筛选目的港口
      if (destinationPortFilter && destinationPortFilter.length) {
        data = data.filter((i) =>
          destinationPortFilter.includes(i.v_destinationPort)
        )
      }
      //筛选出货日期
      if (deliveryDateFilter && deliveryDateFilter.length) {
        data = data.filter((i) => deliveryDateFilter.includes(i.deliveryDate))
      }
      //筛选客户交期
      if (shipmentDateFilter && shipmentDateFilter.length) {
        data = data.filter((i) => shipmentDateFilter.includes(i.shipmentDate))
      }
      //筛选产品识别编号
      if (identifyGoodsNoFilter && identifyGoodsNoFilter.length) {
        data = data.filter((i) =>
          identifyGoodsNoFilter.includes(i.identifyGoodsNo)
        )
      }
      //执行工厂
      if (executeScmNameFilter && executeScmNameFilter.length) {
        data = data.filter((i) =>
          executeScmNameFilter.includes(i.executeScmName)
        )
      }
      //结算工厂
      if (settlementFactoryNameFilter && settlementFactoryNameFilter.length) {
        data = data.filter((i) =>
          settlementFactoryNameFilter.includes(i.settlementFactoryName)
        )
      }
      //业务性质
      if (orderExecuteTypeFilter && orderExecuteTypeFilter.length) {
        data = data.filter((i) =>
          orderExecuteTypeFilter.includes(i.v_orderExecuteType)
        )
      }
      this.v_tableData = data
    },
  },
}
</script>
